module.exports = __webpack_public_path__ + "a087060d512cfdf74bef649bf2748c7b.svg";